<template>
	<div class="service">
		<div class="service__body">
			<h5 class="service__name">{{ article.title }}</h5>
			<p class="service__description">{{ cleanDesc }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "LinkCard",
	props: ["article"],
	methods: {
		truncText: function (text, length) {
			if (!text) return "";
			let trim;
			if (text.length > length) {
				trim = text.substr(0, length);
				trim = trim.substr(
					0,
					Math.min(trim.length, trim.lastIndexOf(" "))
				);
				trim = trim + "...";
			} else {
				trim = text;
			}
			return trim;
		},
	},
	computed: {
		cleanDesc: function () {
			if (!this.article || !this.article.description) return "";
			let text = this.article.description;
			return this.truncText(text, 80);
		},
	},
};
</script>

<style scoped>

.service {
	display: flex;
	align-items: center;
	border: 1px solid var(--clr-accent-primary);
	border-radius: 0.2em;
	padding: 1em 1.2em;
	margin-bottom: 1rem;
}

.service:hover {
	cursor: pointer;
	background-color: var(--clr-accent-primary-shade-1);
}

.service__icon {
	width: 3.2rem;
	height: 3.2rem;
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	margin-right: 2rem;
}

.service__name {
	color: var(--clr-accent-primary);
}

.service__description {
	color: var(--clr-neutral-shade-6);
	margin-bottom: 0;
}

.hyper-dispatch-icon {
	background-image: url("../../../assets/icons/HyperDispatch.svg");
}
.hyper-crawl-icon {
	background-image: url("../../../assets/icons/HyperCrawl.svg");
}
.hyper-learn-icon {
	background-image: url("../../../assets/icons/HyperLearn.svg");
}
.hyper-social-icon {
	background-image: url("../../../assets/icons/HyperSocial.svg");
}
.hyper-mail-icon {
	background-image: url("../../../assets/icons/HyperMail.svg");
}
.hyper-store-icon {
	background-image: url("../../../assets/icons/HyperDispatch.svg");
}
.hyper-auth-icon {
	background-image: url("../../../assets/icons/HyperAuth.svg");
}

.tex-icon {
	background-image: url("../../../assets/icons/tex.svg");
}
</style>